import axios from "axios";

export const API_URL = "https://service.laek-rlp.de/api";

// fetch login
export const fetchLogin = async (credentials) => {
  try {
    const res = await axios.post(`${API_URL}/login`, credentials);
    return res.data;
  } catch (error) {
    if (!error.response) {
      return 'connection_failed';
    }
    if (error.response.data === 'User already deliverd a Survey') {
      return 'survey_completed';
    } else {
      console.log(error.response.data);
      console.log(error.response.status);

      return error.response.status;
    }
  }
}

// get Data - dynamic questions for Survey
export const getData = async () => {
  const user = JSON.parse(localStorage.getItem('user'));
  try {
    const res = await axios.post(`${API_URL}/data`, {
      einrichtungs_id: user.username
    }, {
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': user.token
      }
    });
    return res.data;
  } catch (error) {
    if (!error.response) {
      return 'connection_failed';
    } else {
      console.log(error.response.data);
      console.log(error.response.status);

      return error.response.status;
    }
  }
}

// get previous Data - what has been saved
export const getPartialData = async () => {
  const user = JSON.parse(localStorage.getItem('user'));
  try {
    const res = await axios.post(`${API_URL}/dataPartial`, {
      einrichtungs_id: user.username
    }, {
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': user.token
      }
    });
    return res.data;
  } catch (error) {
    if (!error.response) {
      return 'connection_failed';
    } else {
      console.log(error.response.data);
      console.log(error.response.status);

      return error.response.status;
    }
  }
}

// save Data
export const saveData = async (data) => {
  const user = JSON.parse(localStorage.getItem('user'));
  await axios.post(`${API_URL}/save`, {
    sessionDaten: data,
    einrichtungs_id: user.username
  }, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'x-access-token': user.token
    }
  });
}
//save partial
export const savePartialData = async (data) => {
  const user = JSON.parse(localStorage.getItem('user'));
  await axios.post(`${API_URL}/savePartial`, {
    sessionDaten: data,
    einrichtungs_id: user.username
  }, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'x-access-token': user.token
    }
  });
}

// upload File
export const uploadFile = async (survey, options) => {
  const user = JSON.parse(localStorage.getItem('user'));
  let formData = new FormData();
  options
    .files
    .forEach(function (file) {
      formData.append(file.name, file);
      formData.append('question', options.name)
      formData.append('einrichtungs_id', user.username)
    });
  let xhr = new XMLHttpRequest();
  xhr.open("POST", `${API_URL}/upload`);
  xhr.setRequestHeader('x-access-token', user.token);
  xhr.onload = function () {
    // let data = JSON.parse(xhr.responseText);
    options.callback("success", options.files.map(function (file) {
      // console.log(file);
      return {
        file: file,
        // content: data[file.name]
        content: file.name
      };
    }));
  };
  xhr.send(formData);
}

// upload Belege - Formular Qualitätssicherung
export const uploadReceipt = async (survey, options) => {
  const user = JSON.parse(localStorage.getItem('user'));
  let formData = new FormData();
  options
    .files
    .forEach(function (file) {
      formData.append(file.name, file);
      formData.append('question', options.name)
      formData.append('einrichtungs_id', user.username)
    });
  let xhr = new XMLHttpRequest();
  xhr.open("POST", `${API_URL}/uploadReceipt`);
  xhr.setRequestHeader('x-access-token', user.token);
  xhr.onload = function () {
    // let data = JSON.parse(xhr.responseText);
    options.callback("success", options.files.map(function (file) {
      return {
        file: file,
        // content: data[file.name]
        content: file.name
      };
    }));
  };
  xhr.send(formData);
}



// Internet Explorer check
function detectIEOrEdge() {
  let ua = window.navigator.userAgent;
  let msie = ua.indexOf("MSIE ");
  let trident = ua.indexOf("Trident/");
  let edge = ua.indexOf("Edge/");
  return edge > 0 || trident > 0 || msie > 0;
}

// download File
export const downloadFile = async (options, token) => {
  await axios.post(`${API_URL}/download`, {
    fileName: options.content
  }, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'x-access-token': token,
    },
    responseType: 'arraybuffer',
    responseEncoding: 'binary'
  }).then((resp) => {
    let file;
    if (detectIEOrEdge()) {
      file = new Blob([resp.data], { type: options.fileValue.type });
    } else {
      file = new File([resp.data], options.fileValue.name, { type: options.fileValue.type });
    }
    let reader = new FileReader();
    reader.onload = function (e) {
      options.callback("success", e.target.result);
    };
    reader.readAsDataURL(file);
  });
}

// save changed Einrichtung Art from dropdown
export const changeArt = async (art) => {
  const user = JSON.parse(localStorage.getItem('user'));
  try {
    const res = await axios.post(`${API_URL}/saveArt`, {
      einrichtungs_id: user.username,
      einrichtungs_art: art
    }, {
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': user.token
      }
    });
    return res.data;
  } catch (error) {
    if (!error.response) {
      return 'connection_failed';
    } else {
      console.log(error.response.data);
      console.log(error.response.status);

      return error.response.status;
    }
  }
}
